import React from 'react';
import PropTypes from 'prop-types';
import DataService from '../../lib/DataService';
import { message, Button } from 'antd';

export default class ImageViewModal extends React.Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    photos: PropTypes.array.isRequired,
    photoIndex: PropTypes.number.isRequired,
    userRoleInfo: PropTypes.object.isRequired,
    postId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      userRoleInfo: props.userRoleInfo,
      photos: props.photos,
      photoIndex: props.photoIndex,
      type: props.type,
      postId: props.postId,
      loading: false,
      recorded: false,
      tag_count_type: 'noChange',
    };
    // bind this
    this.toolFirstPhoto = this.toolFirstPhoto.bind(this);
    this.changeImageIndex = this.changeImageIndex.bind(this);
    this.tagPhoto = this.tagPhoto.bind(this);
    this.deleteTag = this.deleteTag.bind(this);
  }

  componentWillReceiveProps(newProps) {

  }

  componentDidMount() {
    let photos = this.state.photos;
    let recorded = this.state.recorded;
    photos.forEach(function(photo) {
      if(!photo.tagged){
        photo.tagged = photo.tag_id ? true : false;
      }
      if(photo.tagged || photo.tag_id){
        recorded = true
      }
    })
    this.setState({ photos: photos, recorded: recorded})
  }

  toolFirstPhoto(photo) {
    let exName = photo.remote_url.split('.').slice(-1)[0];
    if (["png", "jpg", "jpeg", "gif"].indexOf(exName.toLowerCase()) >= 0) {
      return photo.remote_url+"?imageView2/2/w/450";
    }
  }

  toolPhotos(photo) {
    let exName = photo.remote_url.split('.').slice(-1)[0];
    if (["png", "jpg", "jpeg", "gif"].indexOf(exName.toLowerCase()) >= 0) {
      return photo.remote_url+"?imageView2/1/w/50/h/50";
    }
  }

  changeImageIndex(e) {
    var photoIndex = this.state.photoIndex;
    if(e.currentTarget.dataset.index){
      photoIndex = parseInt(e.currentTarget.dataset.index);
    }else if(e.currentTarget.dataset.arrow) {
      if(e.currentTarget.dataset.arrow == "preview"){
        if(photoIndex > 0){
          photoIndex = photoIndex - 1;
        }else if(photoIndex == 0){
          photoIndex = this.state.photos.length - 1;
        }
      }else if(e.currentTarget.dataset.arrow == "next") {
        if(photoIndex < this.state.photos.length - 1 ){
          photoIndex = photoIndex + 1;
        }else if(photoIndex == this.state.photos.length - 1){
          photoIndex = 0;
        }
      }
    }
    this.setState({
      photoIndex: photoIndex,
    })
  }

  tagPhoto() {
    this.setState({loading: true})
    let data = {
      student_id: this.state.userRoleInfo.associatObj.id,
      upload_file_id: this.state.photos[this.state.photoIndex].id
    }
    DataService.createTag(data).then((response) => {
      this.state.photos[this.state.photoIndex].tagged = true
      this.state.photos[this.state.photoIndex].tag_id = response.id
      this.setState({photos: this.state.photos, loading: false, tag_count_type: this.state.recorded ? 'noChange' : 'addTag'});
    }, (error) => {
      message.error('收入记录失败');
    });
  }

  deleteTag() {
    this.setState({loading: true})
    let photoIndex = this.state.photoIndex;
    let photos = this.state.photos;
    if(photos[photoIndex].tag_id){
      DataService.deleteTag(photos[photoIndex].tag_id).then((response) => {
        photos[photoIndex].tagged = false
        photos[photoIndex].tag_id = null
        if(this.state.type == 'record'){
          if(photos.length == 1){
            photos = [];
            this.setState({photos: photos, loading: false});
            this.props.onCancel();
            this.props.onUntagPost(this.state.postId);
          }else{
            photos.splice(photoIndex, 1)
            if(photoIndex == photos.length){
              photoIndex = photoIndex - 1;
            }
            this.setState({photos: photos, photoIndex: photoIndex, loading: false});
          }
        }else {
          let photoTagged = photos.find((photo) => (photo.tag_id != null) || photo.tagged);
          if(this.state.recorded){
            this.setState({photos: photos, loading: false, tag_count_type: photoTagged ? 'noChange' : 'removeTag'});
          }else{
            this.setState({photos: photos, loading: false, tag_count_type: photoTagged ? 'addTag' : 'noChange'});
          }
        }
      }, (error) => {
        message.error('收入记录失败');
      });
    }else {
      photos[photoIndex].tagged = false
      this.setState({photos: photos, loading: false});
    }
  }

  render() {
    let photoIndex = this.state.photoIndex;
    let photos = this.state.photos;
    return (
      <div className="image-view-modal">
        <div className="image-view-modal-mask" onClick={this.props.onCancel}></div>
        <div className="photos-wrapper">
          <div className="photo-view">
            <span className="photo-view-span"><img src={photos[photoIndex] ? this.toolFirstPhoto(photos[photoIndex]) : ''} className="photo-card-img" /></span>
              <div className="photo-view-arrow-box">
                <div className="photo-view-arrow left" onClick={this.changeImageIndex} data-arrow="preview"></div>
                <div className="photo-view-arrow right" onClick={this.changeImageIndex} data-arrow="next"></div>
              </div>
          </div>
          {photos.length > 0 &&
            <div className="photos-list">
              <div className="photos-list-text">({photoIndex + 1}/{photos.length})</div>
              {photos.map((photo, index)=>
                <div key={index} className="photo-card">
                  <img src={this.toolPhotos(photo)} className="photo-card-img"/>
                  {(photoIndex != index) &&
                    <div className="photo-card-img-cover" onClick={this.changeImageIndex} data-index={index} ></div>
                  }
                </div>
              )}
              {(this.state.userRoleInfo.roleName == "parent" && !photos[photoIndex].tagged) &&
                <Button className="photos-list-btn" type="primary" loading={this.state.loading} onClick={this.tagPhoto}>收入宝贝记录</Button>
              }
              {(this.state.userRoleInfo.roleName == "parent" && photos[photoIndex].tagged) &&
                <div className="photos-list-btn-tagged">
                  <div className="photos-list-btn-text"><span className="photos-list-btn-img"></span>已收入</div>
                  <Button className="photos-list-btn" type="primary" loading={this.state.loading} onClick={this.deleteTag} >取消收入</Button>
                </div>
              }
            </div>
          }
          <div className="image-view-modal-cancel" onClick={this.props.onCancel} data-photos={JSON.stringify(this.state.photos)} data-type={this.state.tag_count_type} ></div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/ImageViewModal.jsx